'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var growthbookReact = require('@growthbook/growthbook-react');
var useTitanAnalytics = require('./titan/useTitanAnalytics.js');
var SessionContext = require('./SessionContext.js');
var index = require('./ClaimBuilder/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const ClaimsGrowthBookProvider = _ref => {
  let {
    growthbookOptions,
    children
  } = _ref;
  const {
    retailerMoniker,
    localeLanguage,
    localeCountry,
    // This is just the original order number from the url
    orderNumber: sessionOrderNumber
  } = SessionContext.useSession();
  const {
    state: {
      claimEligibilityInfo,
      claimType
    }
  } = index.useClaimBuilder();
  const titanAnalytics = useTitanAnalytics["default"]();
  const titanAnalyticsRef = React.useRef(titanAnalytics);
  titanAnalyticsRef.current = titanAnalytics;
  const orderNumber = (claimEligibilityInfo === null || claimEligibilityInfo === void 0 ? void 0 : claimEligibilityInfo.orderNumber) ?? sessionOrderNumber;
  const growthbookAttributes = React.useMemo(() => ({
    assist_retailerMoniker: retailerMoniker,
    assist_localeLanguage: localeLanguage,
    assist_localeCountry: localeCountry,
    assist_orderNumber: orderNumber,
    assist_claimType: claimType
  }), [retailerMoniker, localeLanguage, localeCountry, orderNumber, claimType]);
  const growthbook = React.useRef(undefined);
  if (!growthbook.current && growthbookOptions) {
    growthbook.current = new growthbookReact.GrowthBook({
      ...growthbookOptions,
      attributes: {
        ...growthbookOptions.attributes,
        ...growthbookAttributes
      },
      trackingCallback: (experiment, result) => {
        var _titanAnalyticsRef$cu;
        (_titanAnalyticsRef$cu = titanAnalyticsRef.current) === null || _titanAnalyticsRef$cu === void 0 ? void 0 : _titanAnalyticsRef$cu.track({
          event: 'experiment_viewed',
          properties: {
            experimentId: experiment.key,
            variationId: result.variationId.toString()
          }
        })
        // eslint-disable-next-line no-console
        .catch(e => console.error(e));
      }
    });
  }

  // configure growthbook to autorefresh features when attributes change
  React.useEffect(() => {
    var _growthbook$current;
    (_growthbook$current = growthbook.current) === null || _growthbook$current === void 0 ? void 0 : _growthbook$current.loadFeatures({
      autoRefresh: true
    }).catch(err => {
      // eslint-disable-next-line no-console
      console.error('growthbook.loadFeatures threw', err);
    });
  }, []);
  React.useEffect(() => {
    var _growthbook$current2, _growthbook$current3;
    (_growthbook$current2 = growthbook.current) === null || _growthbook$current2 === void 0 ? void 0 : _growthbook$current2.setAttributes({
      ...((_growthbook$current3 = growthbook.current) === null || _growthbook$current3 === void 0 ? void 0 : _growthbook$current3.getAttributes()),
      ...growthbookAttributes
    }).catch(err => {
      // eslint-disable-next-line no-console
      console.error('growthbook.setAttributes threw', err);
    });
  }, [growthbookAttributes]);
  return /*#__PURE__*/React__default["default"].createElement(growthbookReact.GrowthBookProvider, {
    growthbook: growthbook.current
  }, children);
};

exports["default"] = ClaimsGrowthBookProvider;
